
      <!-- bradcam_area  -->
      <div class="bradcam_area bradcam_bg_3" id="goToTop">
        <div class="container">
            <div class="row">
                <div class="col-xl-12">
                    <div class="bradcam_text">
                        <h3 i18n>Contact us</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--/ bradcam_area  -->
  <!-- ================ contact section start ================= -->
  <section class="contact-section section_padding">
    <div class="container">
      <div class="d-none d-sm-block mb-5 pb-4">
        <div id="map" style="height: 480px;"></div>
     
        
        
      </div>


      <div class="row">
        <div class="col-12">
          <h2 class="contact-title" i18n>Get in Touch</h2>
        </div>
        <div class="col-lg-8">
          <form class="form-contact contact_form" action="contact_process.php" method="post" id="contactForm" novalidate="novalidate">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  
                    <textarea class="form-control w-100" #InputMessage name="message" id="message" (keyup)="onKeyUpForMessage($event)" cols="30" rows="9" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Enter Message'" placeholder = 'Enter Message'></textarea>
                    <div data-aos="fade-right" data-aos-duration="1500" *ngIf="messageError"  style="color: red;" i18n>Please leave us a message !</div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <input class="form-control"  #InputName name="name" (keyup)="onKeyUpForName($event)" id="name" type="text" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Enter your name'" placeholder = 'Enter your name'>
                  <div data-aos="fade-right" data-aos-duration="1500" *ngIf="nameError"  style="color: red;" i18n>Name required !</div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <input class="form-control" #InputEmail name="email" (keyup)="onKeyUpForEmail($event)" id="email" type="email" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Enter email address'" placeholder = 'Enter email address'>
                  <div data-aos="fade-right" data-aos-duration="1500" *ngIf="emailError"  style="color: red;" i18n>Email required !</div>
                  <div data-aos="fade-right" data-aos-duration="1500" *ngIf="emailError_"  style="color: red;" i18n>Please enter a valid email address.</div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <input class="form-control" #InputSubject name="subject" (keyup)="onKeyUpForSubject($event)" id="subject" type="text" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Enter Subject'" placeholder = 'Enter Subject'>
                  <div data-aos="fade-right" data-aos-duration="1500" *ngIf="subjectError"  style="color: red;" i18n>Subject required !</div>
                  <div data-aos="fade-right" data-aos-duration="1500" *ngIf="subjectError_"  style="color: red;" i18n>Must consist of at least 4 characters</div>
                </div>
              </div>
            </div>
            <div class="form-group mt-3">
              <button type="submit" class="d-none d-lg-block button button-contactForm btn_4 boxed-btn submitZoom" (click)="sendMessage(InputMessage,InputName,InputEmail,InputSubject)" i18n>Send Message</button>
              <button type="submit" class="d-block d-lg-none button button-contactForm btn_4 boxed-btn" (click)="sendMessage(InputMessage,InputName,InputEmail,InputSubject)" i18n>Send Message</button>

            </div>
          </form>
        </div>
        <div class="col-lg-4">
          <div class="media contact-info">
            <span class="contact-info__icon"><i class="ti-home"></i></span>
            <div class="media-body">
              <h3>31 Rue Hector Trudel.</h3>
              <p>Beauharnois, QC CA</p>
            </div>
          </div>
          <div class="media contact-info">
            <span class="contact-info__icon"><i class="ti-tablet"></i></span>
            <div class="media-body">
              <h3>001 (438) 404 2421</h3>
              <p i18n>Mon to Fri 9am to 6pm</p>
            </div>
          </div>
          <div class="media contact-info">
            <span class="contact-info__icon"><i class="ti-email"></i></span>
            <div class="media-body">
              <h3>contact@earlytransfert.com</h3>
              <p i18n>Send us your query anytime!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- ================ contact section end ================= -->

